import axios from 'axios'
import { AutomationSchedule } from '../../domain/proposals/settings/proposalSettings'
import api from '../api'
import { uniqueId } from '../../helpers/uniqueId'
import { ProposalCreationParameters } from './proposalsModel'

export const getCreateProposalModel = async (jobId: number): Promise<ProposalCreationParameters> => {
  try {
    const response = await api.get<ProposalCreationParameters>(`/web/proposals/${jobId}/create`)
    return response.data
  } catch (error) {
    throw new Error((error as any).response.data.errorMessage)
  }
}

export const getProposalDraft = async (proposalId: number): Promise<ProposalCreationParameters> => {
  try {
    const response = await api.get<ProposalCreationParameters>(`/web/proposals/${proposalId}/draft`)
    return response.data
  } catch (error) {
    throw new Error((error as any).response.data.message)
  }
}

export const updateProposalDraft = async (proposalId: number, model: ProposalCreationParameters) => {
  return await api.put(`/web/proposals/${proposalId}/draft`, model)
}

export const saveProposal = async (model: ProposalCreationParameters) => {
  return await api.post(`/web/proposals/save`, model)
}

export const createProposal = async (model: ProposalCreationParameters): Promise<number> => {
  const response = await api.post<number>(`/web/proposals/create`, model)
  return response.data
}

type EmailAddress = {
  address: string
}

type ResendProposalRequest = {
  projectId: number
  proposalId: number
  recipients: EmailAddress[]
  emailReplyToAddresses: EmailAddress[]
  emailSubject: string
  emailBody: string
  sendPdf: boolean
  notifySalesPersonOfCustomerViews: boolean
  followUpAutomation: AutomationSchedule | null
  ccRecipients?: EmailAddress[]
}

export const resendProposal = async(request: ResendProposalRequest) => {
  return await api.post(`/web/proposals/send/${request.proposalId}`, request)
}

type ProposalAttachmentUploadResult = {
  attachmentId: string
  filename: string
  name: string
  size: number
}

export const uploadProposalAttachment = async (
  file: File,
  customerId: number,
  jobId: number
): Promise<ProposalAttachmentUploadResult> => {
  const attachmentId = uniqueId()
  const response = await api.post<{ links: { attachmentId: string, link: string, contentType: string }[] }>(
    'attachments/link',
    { files: [{ attachmentId, filename: file.name }] }
  )
  const link = response.data.links[0]

  await axios.create().put(link.link, file, { headers: { 'Content-Type': link.contentType } })

  await api.post('attachments/uploaded', [{
    id: attachmentId,
    customerId,
    jobId,
    name: file.name,
    filename: file.name,
    tags: ''
  }])

  return { attachmentId, filename: file.name, name: file.name, size: file.size }
}
